import React from 'react';

const Editorial = () => {
  return (
    <section id="journal" className="py-32 md:py-48 px-6 bg-[#2C2C2C] text-[#F9F8F6] relative overflow-hidden">
      {/* Background Vignette for Context */}
      <div className="absolute inset-0 z-0 opacity-20">
        <img 
          src="https://images.unsplash.com/photo-1594026112284-02bb6f3352fe?auto=format&fit=crop&w=1600&q=80" 
          alt="" 
          className="w-full h-full object-cover grayscale"
          aria-hidden="true"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#2C2C2C]/80" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <span className="text-xs tracking-[0.3em] uppercase text-[#A3A3A3] mb-10 block font-medium">Our Philosophy</span>
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif leading-[1.3] md:leading-[1.3] lg:leading-[1.3] mb-12 text-balance">
          "We believe your home should be a reflection of how you want to live—unhurried, intentional, and surrounded by beauty."
        </h2>
        <p className="text-[#A3A3A3] max-w-2xl mx-auto text-base md:text-lg font-light leading-relaxed mb-16">
          Every piece in our collection is sourced with care from small workshops and independent makers. We favor natural materials that age gracefully—linen that softens with every wash, unlacquered brass that develops a rich patina, and wood grain that tells a story.
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16 max-w-3xl mx-auto">
          <div className="aspect-square bg-white/5 rounded-sm overflow-hidden">
            <img src="https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=400&q=80" alt="Texture detail" className="w-full h-full object-cover opacity-60 hover:opacity-100 transition-opacity" loading="lazy" />
          </div>
          <div className="aspect-square bg-white/5 rounded-sm overflow-hidden">
            <img src="https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=400&q=80" alt="Material study" className="w-full h-full object-cover opacity-60 hover:opacity-100 transition-opacity" loading="lazy" />
          </div>
          <div className="aspect-square bg-white/5 rounded-sm overflow-hidden">
            <img src="https://images.unsplash.com/photo-1542889601-399c4f3a8402?auto=format&fit=crop&w=400&q=80" alt="Craft detail" className="w-full h-full object-cover opacity-60 hover:opacity-100 transition-opacity" loading="lazy" />
          </div>
          <div className="aspect-square bg-white/5 rounded-sm overflow-hidden">
            <img src="https://images.unsplash.com/photo-1524061614234-8449637d56ce?auto=format&fit=crop&w=400&q=80" alt="Atmospheric detail" className="w-full h-full object-cover opacity-60 hover:opacity-100 transition-opacity" loading="lazy" />
          </div>
        </div>

        <button className="border border-[#F9F8F6] text-[#F9F8F6] px-10 py-4 text-xs md:text-sm tracking-[0.2em] uppercase hover:bg-[#F9F8F6] hover:text-[#2C2C2C] transition-colors duration-300">
          Read the Journal
        </button>
      </div>
    </section>
  );
};

export default Editorial;